import { z } from 'zod';

export const zodContractSuggestionSchema = z.object({
  buyerAssignedId: z.string().nullish(),
  comparableItemCount: z.number().int().nonnegative().default(0),
  contractId: z.uuid(),
  contractName: z.string().nullish(),
  inactiveMatchedItemCount: z.number().int().nonnegative().default(0),
  isCurrent: z.boolean().default(false),
  isItemMismatch: z.boolean(),
  matchedItemCount: z.number().int().nonnegative().default(0),
  // Lower is stronger. 0 is synthetic for a currently linked contract that no
  // longer matches; further ranks may appear. When isCurrent is true, prefer that flag.
  matchRank: z.number().int().nonnegative(),
  sellerAssignedId: z.string().nullish(),
  status: z.string().nullish(),
  // Delivery-note item ids (same as dlnItems[].id on the internal note) with no matching contract position.
  unmatchedItemIds: z.array(z.number().int()).default([]),
  validFrom: z.iso.date().nullish(),
  validUntil: z.iso.date().nullish(),
});

export const zodContractSuggestionsResponseSchema = z.array(
  zodContractSuggestionSchema,
);
